/**
 * The routed content region. It also carries the area accent, so every page inside it wears the hue of the menu section it belongs to.
 *
 * @userstory US-UI-42
 */
import React, { Suspense } from 'react';
import Card, { CardBody } from '../../components/bootstrap/Card';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import SubHeader from '../SubHeader/SubHeader';
import ContentRoutes from './ContentRoutes';
import useAreaAccent from '../../hooks/useAreaAccent';

const LOADING = (
	<PageWrapper>
		<SubHeader>
			<div />
		</SubHeader>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</PageWrapper>
);

const Content = () => {
	// The page wears the hue of the menu section it belongs to. Declared once here so no page has
	// to remember to do it, and so the sidebar row and the page can never disagree (BR-UI-36).
	const areaAccent = useAreaAccent();

	return (
		<main className={`content ${areaAccent}`.trim()}>
			<Suspense fallback={LOADING}>
				<ContentRoutes />
			</Suspense>
		</main>
	);
};

export default Content;
